import { ChangeEvent, useState } from 'react';

export const useInputState = (
  initialText: string
): [
  string,
  React.Dispatch<React.SetStateAction<string>>,
  (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void,
  () => void
] => {
  const [value, setValue] = useState<string>(initialText);
  const handleChange = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void =>
    setValue((event.target as HTMLInputElement).value);
  const reset: () => void = () => setValue('');

  return [value, setValue, handleChange, reset];
};
